/*
 * Start
 *
 * Initialise our application
 */

import BaseComponent from './baseComponent';
import LoadComponents from './loadComponents';
import Menu from './menu';
import ResizeDone from './resizeDone';
import Toggle from './toggle';
import WindowScrollPosition from './windowScrollPosition';
import CustomCursor from './customCursor';
import Context from './context';
import Locale from './locale';
import ScrollToAnchor from './scrollToAnchor';
import ScrollPosition from './scrollPosition';
import Revision from './revision';

export default class Start {

    componentLoader = new LoadComponents();

    // initialise modules
    constructor() {
        this.frame();
        this.content('main');
    }

    // Initialise modules that target DOM elements in the page wrapper,
    // and that do not need to be re-initialised when the content areas is swapped.
    frame() {
        // main menu (desktop)
        new Toggle('.js-menu');
        new Toggle('.js-menu__sub');
        new Menu();
        new ResizeDone();
        new WindowScrollPosition();
        new CustomCursor();
        new Context();
        new ScrollToAnchor();
        new ScrollPosition();
        new Revision();
    }

    // Initialise components in content swapped into the page
    content(target = null) {

        // Load these components on initial page load
        // These *must* be able to update themselves when the DOM mutates, using update()
        this.componentLoader.load('scrollAnimation', '[data-sal]');
        this.componentLoader.load('reveal', '[data-reveal]');
        this.componentLoader.load('freeForm', '[data-form]');

        // Lazy load components when a specific selector enters the DOM within the specified swap target
        this.componentLoader.load('hoverDir', '.o-hover-dir', target);
        this.componentLoader.load('countup', '[data-countup-end]', target);
        this.componentLoader.load('intersect', '[data-intersect]', target);
        this.componentLoader.load('parallax', '[data-parallax]', target);
        this.componentLoader.load('carousels', '[data-carousel]', target);
        this.componentLoader.load('share', '[data-share]', target);
        this.componentLoader.load('backgroundVideo', '[data-background-video]', target);
        this.componentLoader.load('videoPlayer', '[data-videoplayer]', target);
        //this.componentLoader.load('vimeoVideo', '[data-vimeo]', target);
        this.componentLoader.load('worldMap', '[data-worldmap]', target);
        this.componentLoader.load('messages', '[data-messages]', target);
    }
}